/**
 * Classe base para a formatação de dados do tipo color.
 * @author: Adalto Junior
 * Date: 20/08/2014
 */


Monet.Format = Monet.Format || {};
Monet.Format.COLOR = (function () {

    function COLOR(value){

        Monet.Format.Base.apply(this, arguments);

        this.value = value;

        this.toGrid = function () {

            var div = document.createElement("div");
            div.className = 'colorField';
            div.style.background = this.value;

            this.value = div.outerHTML;

            return this;
        };


    }

    return COLOR;

}());